import {
  collection,
  where,
  getFirestore,
  getDocs,
  query,
  setDoc,
  getDoc,
  deleteDoc,
  serverTimestamp,
  doc,
  updateDoc,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import moment from "moment";

import { app } from "../../config/config";
import { REF } from "../ref";
import { TYPES } from "./cashup.type";

const firestore = getFirestore(app);
const auth = getAuth();

//------------------------- snap all income by Staff by Date -----------------------------
let incomeSub = [];
export const snapAllIncomeByDate =
  ({ from, to }, callback) =>
  (dispatch) => {
    const owner = auth?.currentUser?.uid;
    selectIncomeByDateSuccess(dispatch, null);
    const cRef = collection(firestore, "cashUp");
    const start = moment(from?._d)?.startOf("day").toDate();
    const end = moment(to?._d)?.endOf("day").toDate();
    const c0 = where("onDate", ">=", start);
    const c1 = where("onDate", "<=", end);
    const c2 = where("owner", "==", owner);
    const qRef = query(cRef, c0, c1, c2);
    const unSub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        selectIncomeByDateSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
    incomeSub.push(unSub);
  };

export const unSnapIncome = () => (dispatch) => {
  incomeSub.forEach((subscriber) => {
    subscriber();
  });
  incomeSub.length = 0;
};

//------------------------- get all branch by ownerList -----------------------------
export const getAllBranch =
  ({ ownerIdList }, callback) =>
  (dispatch) => {
    if (ownerIdList?.length > 0) {
      const cRef = collection(firestore, "branch");
      const c0 = where("owner", "in", ownerIdList);
      const qRef = query(cRef, c0);
      getDocs(qRef).then((snapshot) => {
        if (snapshot) {
          const data = snapshot.docs.map((doc) => doc.data());
          selectAllBrancheSuccess(dispatch, data);
          if (callback) {
            callback();
          }
        }
      });
    } else {
      selectAllBrancheSuccess(dispatch, []);
    }
  };

//------------------------- get user infi by userList -----------------------------
export const getUserInfo =
  ({ userIdList }, callback) =>
  (dispatch) => {
    if (userIdList.length > 0) {
      const cRef = collection(firestore, "user");
      const c0 = where("id", "in", userIdList);
      const qRef = query(cRef, c0);
      getDocs(qRef).then((snapshot) => {
        if (snapshot) {
          const data = snapshot.docs.map((doc) => doc.data());
          selectUserInfoSuccess(dispatch, data);
          if (callback) {
            callback();
          }
        }
      });
    } else {
      selectUserInfoSuccess(dispatch, []);
    }
  };

//------------------------- dispatch -----------------------------

const selectIncomeByDateSuccess = (dispatch, data) =>
  dispatch({
    type: TYPES.SELECT_ALL_INCOME_SUCCESS,
    payload: data,
  });

const selectAllBrancheSuccess = (dispatch, data) =>
  dispatch({
    type: TYPES.SELECT_ALL_BRANCH_SUCCESS,
    payload: data,
  });

const selectUserInfoSuccess = (dispatch, data) =>
  dispatch({
    type: TYPES.SELECT_USER_INFO_SUCCESS,
    payload: data,
  });

// ------------- Cash up detail -------------- //
// ---------- snap Cashup -------------- //
let cashupSub = [];
export const snapCashupDetail =
  ({ date, branch }, callback) =>
  (dispatch) => {
    selectCashupSuccess(dispatch, null);
    const cRef = collection(firestore, REF.CASHUP);
    const c0 = where("date", "==", date);
    const c1 = where("branch", "==", branch);
    const qRef = query(cRef, c0, c1);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        // nếu có data
        if (data?.length > 0) {
          const detail = data[0];
          selectCashupSuccess(dispatch, detail);
          if (callback) {
            callback(detail);
          }
        } else {
          callback(false);
        }
      }
    });

    cashupSub.push(unsub);
  };

export const unSnapCashup = () => (dispatch) => {
  cashupSub.forEach((subscriber) => {
    subscriber();
  });

  cashupSub.length = 0;
};

// ---------- dispatch -------------- //
const selectCashupSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_DETAIL_CASHUP,
    payload: data,
  });
};

// ---------- snap Cashup -------------- //
let cashupallSub = [];
export const snapAllCashup =
  ({ branch }, callback) =>
  (dispatch) => {
    selectCashupSuccess(dispatch, null);
    const cRef = collection(firestore, REF.CASHUP);
    const prevMonth = moment().subtract(1, "months")?.toDate();
    const c0 = where("createAt", ">=", prevMonth);
    const c1 = where("branch", "==", branch);
    const qRef = query(cRef, c0, c1);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        // nếu có data
        if (data?.length > 0) {
          if (callback) {
            callback(data);
          }
        } else {
          callback(false);
        }
      }
    });

    cashupallSub.push(unsub);
  };

export const unSnapAllCashup = () => (dispatch) => {
  cashupallSub.forEach((subscriber) => {
    subscriber();
  });

  cashupallSub.length = 0;
};

// ---------- Add cashup -------------- //
export const addCashUp =
  ({ data }, callback) =>
  (dispatch) => {
    // console.log({data})
    const date = data?.date;
    const branch = data?.branch;
    const cRef = collection(firestore, REF.CASHUP);
    const c0 = where("date", "==", date);
    const c1 = where("branch", "==", branch);
    const qRef = query(cRef, c0, c1);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const dataCashup = snapshot.docs.map((doc) => doc.data());
        // có data rồi
        if (dataCashup?.length > 0) {
          const detail = dataCashup[0];
          const id = detail?.id;
          const update = {
            ...detail,
            ...data,
            updateAt: serverTimestamp(),
          };
          const dRef = doc(cRef, id);
          updateDoc(dRef, update)
            .then(() => {
              if (callback) {
                callback({
                  status: 200,
                });
              }
            })
            .catch((err) => {
              if (callback) {
                callback({
                  status: 500,
                  data: err?.message || "Please try again!",
                });
              }
            });
        } else {
          // chưa có data, tạo mới
          let id = doc(cRef).id;
          let onDate = moment(date, "DD/MM/YYYY")?.toDate();
          const dRef = doc(cRef, id);
          let created = {
            ...data,
            id,
            onDate,
            createAt: serverTimestamp(),
          };

          setDoc(dRef, created, { merge: true })
            .then(() => {
              if (callback) {
                callback({
                  status: 200,
                });
              }
            })
            .catch((err) => {
              if (callback) {
                callback({
                  status: 500,
                  data: err?.message || "Please try again!",
                });
              }
            });
        }
      }
    });
  };

// get All Cashup
export const gelAllCashup = (callback) => (dispatch) => {
  const cRef = collection(firestore, "cashUp");
  getDocs(cRef).then((snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      if (callback) {
        callback(data);
      }
    }
  });
};
